import React, { useState } from "react";
import "../../Styles/JanataDarbarTable.css";
import { useNavigate } from "react-router-dom";

const AdminJanataDarbarTable = () => {
  const navigate = useNavigate();

  const initialData = [
    {
      id: 1,
      token: "JD-0451",
      name: "Chintakayala Ramulamma",
      mobile: "9876543210",
      age: "58",
      category: "Pension",
      village: "Gudluru",
      mandal: "Gudluru",
      date: "18-07-2026",
      status: "Resolved",
      avatarBg: "darb123-avatar-purple",
      initials: "CR",
    },
    {
      id: 2,
      token: "JD-0452",
      name: "Tummala Prasad",
      mobile: "9123456780",
      age: "34",
      category: "Land Dispute",
      village: "Kandukur",
      mandal: "Kandukur",
      date: "18-07-2026",
      status: "In Progress",
      avatarBg: "darb123-avatar-blue",
      initials: "TP",
    },
    {
      id: 3,
      token: "JD-0453",
      name: "Bhavanam Sujatha",
      mobile: "9988776655",
      age: "41",
      category: "Financial Aid",
      village: "Ulavapadu",
      mandal: "Ulavapadu",
      date: "19-07-2026",
      status: "Pending",
      avatarBg: "darb123-avatar-pink",
      initials: "BS",
    },
  ];

  const [visitors, setVisitors] = useState(initialData);

  const [search, setSearch] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("All Categories");
  const [mandalFilter, setMandalFilter] = useState("All Mandals");
  const [statusFilter, setStatusFilter] = useState("All Status");
  const [currentPage, setCurrentPage] = useState(1);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const totalPages = 46;

  const resetFilters = () => {
    setSearch("");
    setCategoryFilter("All Categories");
    setMandalFilter("All Mandals");
    setStatusFilter("All Status");
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // ---------- SEARCH + FILTER LOGIC ----------
  const filteredVisitors = visitors.filter((item) => {
    const searchLower = search.trim().toLowerCase();

    const matchesSearch =
      searchLower === "" ||
      item.name.toLowerCase().includes(searchLower) ||
      item.token.toLowerCase().includes(searchLower) ||
      item.mobile.includes(searchLower);

    const matchesCategory =
      categoryFilter === "All Categories" || item.category === categoryFilter;

    const matchesMandal =
      mandalFilter === "All Mandals" || item.mandal === mandalFilter;

    const matchesStatus =
      statusFilter === "All Status" || item.status === statusFilter;

    return matchesSearch && matchesCategory && matchesMandal && matchesStatus;
  });

  // ---------- EDIT LOGIC ----------
  const openEditModal = (item) => {
    setEditItem({ ...item });
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditItem(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditItem((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSave = (e) => {
    e.preventDefault();
    setVisitors((prev) =>
      prev.map((item) => (item.id === editItem.id ? editItem : item))
    );
    closeEditModal();
  };

  // ---------- STATS ----------
  const totalVisitors = visitors.length;
  const resolvedCount = visitors.filter((v) => v.status === "Resolved").length;
  const inProgressCount = visitors.filter((v) => v.status === "In Progress").length;
  const pendingCount = visitors.filter((v) => v.status === "Pending").length;

  const getStatusClass = (status) => {
    switch (status) {
      case "Resolved":
        return "darb123-status-resolved";
      case "In Progress":
        return "darb123-status-progress";
      case "Pending":
        return "darb123-status-pending";
      default:
        return "";
    }
  };

  const todayDisplay = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  return (
    <div className="darb123-page">
      {/* Header */}
      <div className="darb123-header">
        <div>
          <h2 className="darb123-title">Janata Darbar</h2>
          <p className="darb123-subtitle">
            Manage visitors who met during Janata Darbar.
          </p>
        </div>

        <div className="darb123-header-right">
          <div className="darb123-date-chip">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
              <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
            {todayDisplay}
          </div>

          <button
            className="darb123-add-btn"
            onClick={() => navigate("/AdminDashboard/JanataDarbarForm")}
          >
            <span className="darb123-add-icon">+</span> Add New Visitor
          </button>
        </div>
      </div>

      {/* Stat Cards */}
      <div className="darb123-stats-grid">
        <div className="darb123-stat-card darb123-stat-card-blue">
          <div className="darb123-stat-icon darb123-stat-icon-blue">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.7" />
              <path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
              <circle cx="17" cy="8" r="2.6" stroke="currentColor" strokeWidth="1.7" />
              <path d="M15.5 14.7c2.6.4 4.5 2.3 4.5 5.3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
            </svg>
          </div>
          <div className="darb123-stat-info">
            <span className="darb123-stat-label">Total Visitors</span>
            <span className="darb123-stat-value">{totalVisitors}</span>
            <span className="darb123-stat-sub darb123-sub-up">↑ 32 this month</span>
          </div>
        </div>

        <div className="darb123-stat-card darb123-stat-card-green">
          <div className="darb123-stat-icon darb123-stat-icon-green">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
              <path d="M8.5 12.5l2.5 2.5 4.5-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="darb123-stat-info">
            <span className="darb123-stat-label">Resolved Cases</span>
            <span className="darb123-stat-value">{resolvedCount}</span>
            <span className="darb123-stat-sub darb123-sub-up">↑ 18 this month</span>
          </div>
        </div>

        <div className="darb123-stat-card darb123-stat-card-purple">
          <div className="darb123-stat-icon darb123-stat-icon-purple">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
              <path d="M12 7v5l3.5 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="darb123-stat-info">
            <span className="darb123-stat-label">In Progress Cases</span>
            <span className="darb123-stat-value">{inProgressCount}</span>
            <span className="darb123-stat-sub darb123-sub-up">↑ 12 this month</span>
          </div>
        </div>

        <div className="darb123-stat-card darb123-stat-card-orange">
          <div className="darb123-stat-icon darb123-stat-icon-orange">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M6 3h12M6 21h12M8 3c0 4 8 4 8 8s-8 4-8 8M16 3c0 4-8 4-8 8s8 4 8 8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="darb123-stat-info">
            <span className="darb123-stat-label">Pending Cases</span>
            <span className="darb123-stat-value">{pendingCount}</span>
            <span className="darb123-stat-sub darb123-sub-down">↓ 8 this month</span>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="darb123-filters">
        <div className="darb123-search-box">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
            <path d="M21 21l-4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
          <input
            type="text"
            placeholder="Search by Name, Token or Mobile..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>

        <select
          className="darb123-select"
          value={categoryFilter}
          onChange={(e) => {
            setCategoryFilter(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Categories</option>
          <option>Land Dispute</option>
          <option>Pension</option>
          <option>Financial Aid</option>
          <option>Employment</option>
          <option>Health</option>
          <option>Police Matter</option>
          <option>Personal</option>
          <option>Other</option>
        </select>

        <select
          className="darb123-select"
          value={mandalFilter}
          onChange={(e) => {
            setMandalFilter(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Mandals</option>
          <option>Kandukur</option>
          <option>Gudluru</option>
          <option>Ulavapadu</option>
        </select>

        <select
          className="darb123-select"
          value={statusFilter}
          onChange={(e) => {
            setStatusFilter(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Status</option>
          <option>Resolved</option>
          <option>In Progress</option>
          <option>Pending</option>
        </select>

        <button className="darb123-reset-btn" onClick={resetFilters}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 4v6h6M20 20v-6h-6M4.5 15a8 8 0 0014.5 3.5M19.5 9A8 8 0 005 5.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Clear Filters
        </button>
      </div>

      {/* Table */}
      <div className="darb123-table-wrapper">
        <table className="darb123-table">
          <thead>
            <tr>
              <th>Token No.</th>
              <th>Visitor Name</th>
              <th>Mobile</th>
              <th>Age</th>
              <th>Category</th>
              <th>Village</th>
              <th>Mandal</th>
              <th>Visit Date</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredVisitors.length === 0 ? (
              <tr>
                <td colSpan="10" className="darb123-no-data">
                  No visitors found.
                </td>
              </tr>
            ) : (
              filteredVisitors.map((item) => (
                <tr key={item.id}>
                  <td>
                    <span className="darb123-token-badge">{item.token}</span>
                  </td>

                  <td>
                    <div className="darb123-name-cell">
                      <div className={`darb123-avatar ${item.avatarBg}`}>
                        {item.initials}
                      </div>
                      {item.name}
                    </div>
                  </td>

                  <td>
                    <div className="darb123-mobile-cell">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                        <path d="M22 16.9v3a2 2 0 01-2.2 2 19.8 19.8 0 01-8.6-3.1 19.5 19.5 0 01-6-6A19.8 19.8 0 012.1 4.2 2 2 0 014.1 2h3a2 2 0 012 1.7c.1.9.3 1.8.6 2.7a2 2 0 01-.5 2.1L8 9.7a16 16 0 006 6l1.2-1.2a2 2 0 012.1-.5c.9.3 1.8.5 2.7.6a2 2 0 011.7 2z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
                      </svg>
                      {item.mobile}
                    </div>
                  </td>

                  <td>{item.age}</td>

                  <td>
                    <span className="darb123-category-badge">{item.category}</span>
                  </td>

                  <td>
                    <div className="darb123-place-cell">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M12 22s7-6.5 7-12a7 7 0 10-14 0c0 5.5 7 12 7 12z"
                          stroke="currentColor"
                          strokeWidth="1.7"
                          strokeLinejoin="round"
                        />
                        <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.7" />
                      </svg>
                      {item.village}
                    </div>
                  </td>

                  <td>
                    <div className="darb123-place-cell">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M12 22s7-6.5 7-12a7 7 0 10-14 0c0 5.5 7 12 7 12z"
                          stroke="currentColor"
                          strokeWidth="1.7"
                          strokeLinejoin="round"
                        />
                        <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.7" />
                      </svg>
                      {item.mandal}
                    </div>
                  </td>

                  <td>
                    <div className="darb123-date-cell">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.7" />
                        <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                      </svg>
                      {item.date}
                    </div>
                  </td>

                  <td>
                    <span className={`darb123-status-badge ${getStatusClass(item.status)}`}>
                      {item.status === "Resolved" && (
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.2" />
                          <path d="M8.5 12.5l2.5 2.5 4.5-5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      )}
                      {item.status === "In Progress" && (
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.2" />
                          <path d="M12 7v5l3.5 2" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      )}
                      {item.status === "Pending" && (
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.2" />
                          <path d="M12 8v4l2.5 1.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      )}
                      {item.status}
                    </span>
                  </td>

                  <td>
                    <div className="darb123-action-cell">
                      <button
                        className="darb123-edit-btn"
                        onClick={() => openEditModal(item)}
                        title="Edit"
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                          <path
                            d="M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z"
                            stroke="currentColor"
                            strokeWidth="1.9"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="darb123-pagination-bar">
        <span className="darb123-pagination-info">
          Showing 1 to {filteredVisitors.length} of {totalVisitors} entries
        </span>

        <div className="darb123-pagination-controls">
          <button
            className="darb123-page-arrow"
            onClick={() => handlePageChange(currentPage - 1)}
          >
            &lt;
          </button>

          {[1, 2, 3].map((p) => (
            <button
              key={p}
              className={`darb123-page-num ${currentPage === p ? "darb123-active" : ""}`}
              onClick={() => handlePageChange(p)}
            >
              {p}
            </button>
          ))}

          <span className="darb123-page-dots">...</span>

          <button
            className={`darb123-page-num ${currentPage === totalPages ? "darb123-active" : ""}`}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>

          <button
            className="darb123-page-arrow"
            onClick={() => handlePageChange(currentPage + 1)}
          >
            &gt;
          </button>
        </div>
      </div>

      {/* Note Footer */}
      <div className="darb123-note-bar">
        <div className="darb123-note-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.7" />
            <path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
            <circle cx="17" cy="8" r="2.6" stroke="currentColor" strokeWidth="1.7" />
            <path d="M15.5 14.7c2.6.4 4.5 2.3 4.5 5.3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
          </svg>
        </div>
        <div>
          <strong>Note</strong>
          <p>Janata Darbar is held every Saturday from 10:00 AM to 2:00 PM.</p>
        </div>
      </div>

      {/* ---------------- EDIT MODAL ---------------- */}
      {showEditModal && editItem && (
        <div className="darb123-modal-overlay" onClick={closeEditModal}>
          <div className="darb123-modal" onClick={(e) => e.stopPropagation()}>
            <div className="darb123-modal-header">
              <h3>Edit Visitor</h3>
              <button className="darb123-modal-close" onClick={closeEditModal}>
                &times;
              </button>
            </div>

            <form className="darb123-modal-body" onSubmit={handleEditSave}>
              <div className="darb123-form-row">
                <div className="darb123-form-group">
                  <label>Token No.</label>
                  <input
                    type="text"
                    name="token"
                    value={editItem.token}
                    onChange={handleEditChange}
                    required
                  />
                </div>

                <div className="darb123-form-group">
                  <label>Visitor Name</label>
                  <input
                    type="text"
                    name="name"
                    value={editItem.name}
                    onChange={handleEditChange}
                    required
                  />
                </div>
              </div>

              <div className="darb123-form-row">
                <div className="darb123-form-group">
                  <label>Mobile</label>
                  <input
                    type="text"
                    name="mobile"
                    value={editItem.mobile}
                    onChange={handleEditChange}
                    required
                  />
                </div>

                <div className="darb123-form-group">
                  <label>Age</label>
                  <input
                    type="text"
                    name="age"
                    value={editItem.age}
                    onChange={handleEditChange}
                    required
                  />
                </div>
              </div>

              <div className="darb123-form-group">
                <label>Category</label>
                <select name="category" value={editItem.category} onChange={handleEditChange}>
                  <option>Land Dispute</option>
                  <option>Pension</option>
                  <option>Financial Aid</option>
                  <option>Employment</option>
                  <option>Health</option>
                  <option>Police Matter</option>
                  <option>Personal</option>
                  <option>Other</option>
                </select>
              </div>

              <div className="darb123-form-row">
                <div className="darb123-form-group">
                  <label>Village</label>
                  <input
                    type="text"
                    name="village"
                    value={editItem.village}
                    onChange={handleEditChange}
                    required
                  />
                </div>

                <div className="darb123-form-group">
                  <label>Mandal</label>
                  <input
                    type="text"
                    name="mandal"
                    value={editItem.mandal}
                    onChange={handleEditChange}
                    required
                  />
                </div>
              </div>

              <div className="darb123-form-row">
                <div className="darb123-form-group">
                  <label>Visit Date</label>
                  <input
                    type="text"
                    name="date"
                    placeholder="DD-MM-YYYY"
                    value={editItem.date}
                    onChange={handleEditChange}
                    required
                  />
                </div>

                <div className="darb123-form-group">
                  <label>Status</label>
                  <select name="status" value={editItem.status} onChange={handleEditChange}>
                    <option>Resolved</option>
                    <option>In Progress</option>
                    <option>Pending</option>
                  </select>
                </div>
              </div>

              <div className="darb123-modal-footer">
                <button
                  type="button"
                  className="darb123-btn-cancel"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>
                <button type="submit" className="darb123-btn-save">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminJanataDarbarTable;